export * from './theme';

const env = { ...process.env };

export const getApiUrl = () => env.REACT_APP_API_URL;

export const getSessionCookieName = () => env.REACT_APP_SESSION_COOKIE;

export const getMixpanelToken = () => env.REACT_APP_MIXPANEL_TOKEN;

export const getSentryDsn = () => env.REACT_APP_SENTRY_DSN;

export const getEnv = () => env.REACT_APP_ENV;

export const isProductionEnv = () => getEnv() === 'production';
